import { render, staticRenderFns } from "./AlturaMora.vue?vue&type=template&id=06f6f7a7&"
import script from "./AlturaMora.vue?vue&type=script&lang=js&"
export * from "./AlturaMora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports